import { render, staticRenderFns } from "./productViewDialogNew.vue?vue&type=template&id=52a654a9&scoped=true"
import script from "./productViewDialogNew.vue?vue&type=script&lang=js"
export * from "./productViewDialogNew.vue?vue&type=script&lang=js"
import style0 from "./productViewDialogNew.vue?vue&type=style&index=0&id=52a654a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a654a9",
  null
  
)

export default component.exports